import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'cboard.components.CommunicatorDialog.title',
    defaultMessage: 'My Communicator'
  },
  menu: {
    id: 'cboard.components.CommunicatorDialog.menu',
    defaultMessage: 'Menu'
  },
  menuRootBoardOption: {
    id: 'cboard.components.CommunicatorDialog.menuRootBoardOption',
    defaultMessage: 'Set as Root Board'
  },
  menuPublishOption: {
    id: 'cboard.components.CommunicatorDialog.menuPublishOption',
    defaultMessage: 'Publish Board'
  },
  menuUnpublishOption: {
    id: 'cboard.components.CommunicatorDialog.menuUnpublishOption',
    defaultMessage: 'Unpublish Board'
  },
  emptyBoardsList: {
    id: 'cboard.components.CommunicatorDialog.emptyBoardsList',
    defaultMessage: 'No boards :('
  },
  loadNextPage: {
    id: 'cboard.components.CommunicatorDialog.loadNextPage',
    defaultMessage: 'Load More'
  },
  search: {
    id: 'cboard.components.CommunicatorDialog.search',
    defaultMessage: 'Search'
  },
  author: {
    id: 'cboard.components.CommunicatorDialog.author',
    defaultMessage: 'By {author}'
  },
  addBoard: {
    id: 'cboard.components.CommunicatorDialog.addBoard',
    defaultMessage: 'Add Board'
  },
  removeBoard: {
    id: 'cboard.components.CommunicatorDialog.removeBoard',
    defaultMessage: 'Remove Board'
  },
  communicatorBoards: {
    id: 'cboard.components.CommunicatorDialog.communicatorBoards',
    defaultMessage: 'Boards'
  },
  allBoards: {
    id: 'cboard.components.CommunicatorDialog.allBoards',
    defaultMessage: 'Public Boards'
  },
  myBoards: {
    id: 'cboard.components.CommunicatorDialog.myBoards',
    defaultMessage: 'All My Boards'
  },
  boardsQty: {
    id: 'cboard.components.CommunicatorDialog.boardsQty',
    defaultMessage: '{qty} boards'
  },
  helpAndSupport: {
    id: 'cboard.components.CommunicatorDialog.helpAndSupport',
    defaultMessage: 'Help And Support'
  },
  termsOfService: {
    id: 'cboard.components.CommunicatorDialog.termsOfService',
    defaultMessage: 'Terms Of Service'
  },
  tilesQty: {
    id: 'cboard.components.CommunicatorDialog.tilesQty',
    defaultMessage: '{qty} Tiles'
  },
  boardInfo: {
    id: 'cboard.components.CommunicatorDialog.boardInfo',
    defaultMessage: 'Board Information'
  },
  boardAddedToCommunicator: {
    id: 'cboard.components.CommunicatorDialog.boardAddedToCommunicator',
    defaultMessage: 'Board successfully added to your Communicator'
  },
  boardRemovedFromCommunicator: {
    id: 'cboard.components.CommunicatorDialog.boardRemovedFromCommunicator',
    defaultMessage: 'Board successfully removed from your Communicator'
  },
  close: {
    id: 'cboard.components.CommunicatorDialog.close',
    defaultMessage: 'Close'
  },
  boardInfoName: {
    id: 'cboard.components.CommunicatorDialog.boardInfoName',
    defaultMessage: 'Board name'
  },
  boardInfoAuthor: {
    id: 'cboard.components.CommunicatorDialog.boardInfoAuthor',
    defaultMessage: 'Board Author'
  },
  boardInfoTiles: {
    id: 'cboard.components.CommunicatorDialog.boardInfoTiles',
    defaultMessage: 'Number of tiles'
  },
  boardInfoId: {
    id: 'cboard.components.CommunicatorDialog.boardInfoId',
    defaultMessage: 'Board ID'
  },
  boardInfoUrl: {
    id: 'cboard.components.CommunicatorDialog.boardInfoUrl',
    defaultMessage: 'Board URL'
  },
  boardInfoDate: {
    id: 'cboard.components.CommunicatorDialog.boardInfoDate',
    defaultMessage: 'Last edited'
  },
  boardDescription: {
    id: 'cboard.components.CommunicatorDialog.boardDescription',
    defaultMessage: 'Description'
  },
  boardPublished: {
    id: 'cboard.components.CommunicatorDialog.boardPublished',
    defaultMessage:
      'Board successfully published! Everybody can see your board now.'
  },
  boardUnpublished: {
    id: 'cboard.components.CommunicatorDialog.boardUnpublished',
    defaultMessage: 'Board was unpublished! Nobody can see your board now.'
  },
  boardDeleted: {
    id: 'cboard.components.CommunicatorDialog.boardDeleted',
    defaultMessage: 'Board was permanently deleted.'
  },
  rootBoard: {
    id: 'cboard.components.CommunicatorDialog.rootBoard',
    defaultMessage: 'Root Board'
  },
  publicBoard: {
    id: 'cboard.components.CommunicatorDialog.publicBoard',
    defaultMessage: 'Public Board'
  },
  privateBoard: {
    id: 'cboard.components.CommunicatorDialog.privateBoard',
    defaultMessage: 'Private Board'
  },
  activeBoard: {
    id: 'cboard.components.CommunicatorDialog.activeBoard',
    defaultMessage: 'Active Board'
  },
  copyBoard: {
    id: 'cboard.components.CommunicatorDialog.copyBoard',
    defaultMessage: 'Copy Board into your communicator'
  },
  copyBoardDescription: {
    id: 'cboard.components.CommunicatorDialog.copyBoardDescription',
    defaultMessage:
      'This action will create a copy of the public board and will add it into your communicator. Do you want to proceed?'
  },
  deleteBoard: {
    id: 'cboard.components.CommunicatorDialog.deleteBoard',
    defaultMessage: 'Delete Board'
  },
  deleteBoardDescription: {
    id: 'cboard.components.CommunicatorDialog.deleteBoardDescription',
    defaultMessage:
      'This action will delete the board and it cannot be recovered. Do you want to proceed?'
  },
  publishBoard: {
    id: 'cboard.components.CommunicatorDialog.publishBoard',
    defaultMessage: 'Board Description'
  },
  publishBoardDescription: {
    id: 'cboard.components.CommunicatorDialog.publishBoardDescription',
    defaultMessage:
      'Please provide a short description about the content of the board and what is the board intended for.'
  },
  accept: {
    id: 'cboard.components.CommunicatorDialog.accept',
    defaultMessage: 'Accept'
  },
  imageBoard: {
    id: 'cboard.components.CommunicatorDialog.imageBoard',
    defaultMessage: 'Edit Board Image'
  },
  imageBoardDescription: {
    id: 'cboard.components.CommunicatorDialog.imageBoardDescription',
    defaultMessage: 'You can either upload or look for symbols from libraries.'
  },
  imageSearch: {
    id: 'cboard.components.CommunicatorDialog.imageSearch',
    defaultMessage: 'Search for symbols'
  },
  editBoardTitle: {
    id: 'cboard.components.CommunicatorDialog.editBoardTitle',
    defaultMessage: 'Edit board name and description'
  },
  editBoardTitleDescription: {
    id: 'cboard.components.CommunicatorDialog.editBoardTitleDescription',
    defaultMessage:
      'You can edit board name and description from here. Please consider to write a meaningful description for your board.'
  },
  noTitle: {
    id: 'cboard.components.CommunicatorDialog.noTitle',
    defaultMessage: 'No title'
  },
  boardCopyError: {
    id: 'cboard.components.CommunicatorDialog.boardCopyError',
    defaultMessage: 'ERROR: There was an error trying to get the board.'
  },
  walkthroughCommunicatorTitle: {
    id: 'cboard.components.CommunicatorDialog.walkthroughCommunicatorTitle',
    defaultMessage: 'Welcome to the communicator builder!'
  },
  walkthroughCommunicator: {
    id: 'cboard.components.CommunicatorDialog.walkthroughCommunicator',
    defaultMessage:
      'The communicator builder allows you to build a list of preferred boards for quick access. You can handle boards in order to copy, delete, publish, add and remove them.'
  },
  walkthroughSearch: {
    id: 'cboard.components.CommunicatorDialog.walkthroughSearch',
    defaultMessage:
      'You can always search boards by name or author using this buttton.'
  },
  walkthroughBoards: {
    id: 'cboard.components.CommunicatorDialog.walkthroughBoards',
    defaultMessage:
      'This tab will list all boards included into your communicator.'
  },
  walkthroughPublicBoards: {
    id: 'cboard.components.CommunicatorDialog.walkthroughPublicBoards',
    defaultMessage: 'This tab will list all public boards from all users.'
  },
  walkthroughAllMyBoards: {
    id: 'cboard.components.CommunicatorDialog.walkthroughAllMyBoards',
    defaultMessage: 'This tab will list all of your own boards.'
  },
  walkthroughBoardProperties: {
    id: 'cboard.components.CommunicatorDialog.walkthroughBoardProperties',
    defaultMessage: 'These icons indicate the board properties:'
  },
  walkthroughBoardActionButton: {
    id: 'cboard.components.CommunicatorDialog.walkthroughBoardActionButton',
    defaultMessage: 'Action buttons:'
  },
  walkthroughBoardActionsRemove: {
    id: 'cboard.components.CommunicatorDialog.walkthroughBoardActionsRemove',
    defaultMessage:
      'Quit the board from communicator, but it will not delete the board from the database and it will be still available under All My Boards tab.'
  },
  walkthroughBoardActionsSetBoardAsRoot: {
    id:
      'cboard.components.CommunicatorDialog.walkthroughBoardActionsSetBoardAsRoot',
    defaultMessage:
      'Define the board as the first board to be displayed every time you login to Cboard.'
  },
  walkthroughEndTour: {
    id: 'cboard.components.CommunicatorDialog.walkthroughEndTour',
    defaultMessage: 'End Tour'
  },
  walkthroughCloseTour: {
    id: 'cboard.components.CommunicatorDialog.walkthroughCloseTour',
    defaultMessage: 'Close Tour'
  },
  walkthroughBack: {
    id: 'cboard.components.CommunicatorDialog.walkthroughBack',
    defaultMessage: 'Back'
  },
  walkthroughNext: {
    id: 'cboard.components.CommunicatorDialog.walkthroughNext',
    defaultMessage: 'Next'
  },
  walkthroughPublicBoardsCopy: {
    id: 'cboard.components.CommunicatorDialog.walkthroughPublicBoardsCopy',
    defaultMessage:
      'Copy the public board and add it into your communicator. This option will create a copy of the public board, and it will not modify the original board.'
  },
  walkthroughPublicBoardsDetail: {
    id: 'cboard.components.CommunicatorDialog.walkthroughPublicBoardsDetail',
    defaultMessage: 'This buttton will display detailed board information.'
  },
  walkthroughAllMyBoardsRemoveBoard: {
    id:
      'cboard.components.CommunicatorDialog.walkthroughAllMyBoardsRemoveBoard',
    defaultMessage:
      'Remove board from the communicator, but it will not delete the board from the database and it will be still available under All My Boards tab.'
  },
  walkthroughAllMyBoardsEditBoardImage: {
    id:
      'cboard.components.CommunicatorDialog.walkthroughAllMyBoardsEditBoardImage',
    defaultMessage: 'You can edit the image that represents the board.'
  },
  walkthroughAllMyBoardsEditBoardName: {
    id:
      'cboard.components.CommunicatorDialog.walkthroughAllMyBoardsEditBoardName',
    defaultMessage: 'You can edit the board title and description.'
  },
  walkthroughAllMyBoardsAddBoard: {
    id: 'cboard.components.CommunicatorDialog.walkthroughAllMyBoardsAddBoard',
    defaultMessage: 'Add board into the communicator.'
  },
  walkthroughAllMyBoardsPublishBoard: {
    id:
      'cboard.components.CommunicatorDialog.walkthroughAllMyBoardsPublishBoard',
    defaultMessage:
      'Publish board: Make your board public. The board will be displayed under the Public Boards tab.'
  },
  walkthroughAllMyBoardsUnpublishBoard: {
    id:
      'cboard.components.CommunicatorDialog.walkthroughAllMyBoardsUnpublishBoard',
    defaultMessage:
      "Unpublish board: Make your board private. The board won't be displayed under the Public Boards tab."
  },
  walkthroughAllMyBoardsDeleteBoard: {
    id:
      'cboard.components.CommunicatorDialog.walkthroughAllMyBoardsDeleteBoard',
    defaultMessage:
      'Delete your board from the database, and it cannot be recovered.'
  },
  boardReport: {
    id: 'cboard.components.CommunicatorDialog.boardReport',
    defaultMessage: 'Report this Board'
  },
  boardReportContentSubtitle: {
    id: 'cboard.components.CommunicatorDialog.boardReportContentSubtitle',
    defaultMessage:
      'Please let us know if you consider that this board includes sexual, violent, hateful, or abusive content'
  },
  boardReportError: {
    id: 'cboard.components.CommunicatorDialog.boardReportError',
    defaultMessage: 'An error occurred sending your report. Please try again.'
  },
  boardReportCancel: {
    id: 'cboard.components.CommunicatorDialog.boardReportCancel',
    defaultMessage: 'Cancel'
  },
  boardReportSend: {
    id: 'cboard.components.CommunicatorDialog.boardReportSend',
    defaultMessage: 'Send report'
  },
  boardReportSuccesSubtitle: {
    id: 'cboard.components.CommunicatorDialog.boardReportSuccesSubtitle',
    defaultMessage: 'Report sent to support team successfully.'
  },
  boardReportSuccesGratitude: {
    id: 'cboard.components.CommunicatorDialog.boardReportSuccesGratitude',
    defaultMessage:
      'Thanks for helping Cboard to be out of inappropriate content.'
  },
  boardReportClose: {
    id: 'cboard.components.CommunicatorDialog.boardReportClose',
    defaultMessage: 'Close'
  },
  boardNotEmpty: {
    id: 'cboard.components.CommunicatorDialog.boardNotEmpty',
    defaultMessage: 'Board must be empty before deleting'
  }
});
